import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

export function EmptyState({
  glyph = '🔍',
  title,
  children,
  action,
}: {
  glyph?: string;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className={styles.empty} role="status">
      <span className={styles.glyph} aria-hidden="true">
        {glyph}
      </span>
      <h3 className={styles.title}>{title}</h3>
      {children && <p className={styles.body}>{children}</p>}
      {action}
    </div>
  );
}
